/* unplugin-vue-components disabled */import { render } from "./primevue.vue?vue&type=template&id=b56ba8aa"
import script from "./primevue.vue?vue&type=script&lang=js"
export * from "./primevue.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/primevue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b56ba8aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b56ba8aa', __exports__)) {
    api.reload('b56ba8aa', __exports__)
  }
  
  module.hot.accept("./primevue.vue?vue&type=template&id=b56ba8aa", () => {
    api.rerender('b56ba8aa', render)
  })

}


export default __exports__